module.exports = __webpack_public_path__ + "static/media/lamina28act1_4.89dd4d87.png";